import { useMemo, useState } from "react";
import { animeList } from "@/mocks/anime";

const allTags = ["全部", "恋爱", "热血", "治愈", "悬疑", "奇幻", "日常", "音乐"];

export default function Popular() {
  const [active, setActive] = useState("全部");

  const filtered = useMemo(
    () => (active === "全部" ? animeList : animeList.filter((a) => a.tags.includes(active))),
    [active]
  );

  return (
    <section id="popular" className="relative py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-semibold px-4 py-1.5 mb-4">
              <i className="ri-fire-fill"></i>
              大家都在看
            </p>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950">热门番剧推荐</h2>
            <p className="mt-3 text-foreground-700 text-sm md:text-base leading-relaxed">
              点击题材标签，快速筛选出合口味的佳作。纠结看什么？先从这些开始。
            </p>
          </div>
          <a
            href="#categories"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#categories")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 cursor-pointer"
          >
            浏览全部分类
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap gap-2 mb-8 md:mb-10">
          {allTags.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(t)}
              className={`whitespace-nowrap rounded-full px-5 py-2 text-sm font-medium transition-colors cursor-pointer ${
                active === t
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 border border-background-200 text-foreground-700 hover:bg-background-200/60"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {filtered.map((anime) => (
            <article
              key={anime.id}
              className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:-translate-y-1 transition-transform duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden">
                <img
                  src={anime.image}
                  alt={`小缘动漫库推荐番剧：${anime.title}`}
                  className="w-full h-56 md:h-64 object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 right-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/70 text-white text-xs font-bold px-2.5 py-1">
                  <i className="ri-star-fill text-accent-400"></i>
                  {anime.score}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg text-foreground-950">{anime.title}</h3>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {anime.tags.map((t) => (
                    <span key={t} className="rounded-full bg-background-200/70 text-foreground-700 text-xs px-2.5 py-0.5">
                      {t}
                    </span>
                  ))}
                </div>
                <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {anime.synopsis}
                </p>
              </div>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="text-center text-foreground-600 text-sm py-10">这个分类下暂时没有匹配的番剧，换个题材试试吧。</p>
        )}
      </div>
    </section>
  );
}